<template>
    <div class="cartcontroll notranslate">
        <transition name="slide-fade" v-show="food.groupId==null">
            <mu-button icon color="primary" :class="packageType==0?'decrease':'decrease-buffet'" v-show="food.quantity" @click="decreaseCart">
                <mu-icon value="remove_circle"></mu-icon>
            </mu-button>
        </transition>
        <div :class="packageType==0?'count':'count-buffet'" v-show="food.quantity">{{food.quantity}}</div>

        <mu-button icon color="primary" :class="(addType===true||food.unAdd)?'form-onlyread':'add'" @click="addCart" v-show="(food.groupId==null) || (food.groupId!=null  && food.quantity)">
            <mu-icon value="add_circle"></mu-icon>
        </mu-button>

        <mu-badge :content="food.unPayTip" v-if="food.unPayTip" style="position:absolute;width:180px;left:-150px;top:20px;z-index: 10000;"></mu-badge>

        <mu-badge :content="getWith()" color="#da5b3a" badge-class="badge-class" @click="openTasteSheet(food.groupId)" v-if="(addType===false && !food.unAdd)" v-show="food.groupId!=null && !food.quantity"></mu-badge>

        <mu-bottom-sheet :open.sync="open" style="overflow-y: auto; height: 80%;">
            <mu-list @item-click="closeTasteSheet">
                <mu-sub-header style="padding-left: 10px;font-size: 20px;font-weight: 600;line-height: 24px;padding-top: 5px;">{{food.foodName}}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon notranslate" @click="closeTasteSheet"></mu-icon>
                <div style="margin-bottom: 20px;" v-for="(parentItem,index) in  foodAttribute" :key="index">
                   <div style="font-size: 14px;color: #909399;line-height: 20px;text-align: left;padding-left: 10px;padding-top: 10px;">{{parentItem.attributeName}}</div>
                    <div v-for="item in parentItem.children" @click="selectTastes(item)" :key="item.id" :class="item.isChoice?'stateChoose':'stateNotChoose'" >
                        {{item.attributeName}}&nbsp;&nbsp;
                        <span>|</span>
                        &nbsp;&nbsp;
                        <span style="color: #f01414;font-size: 13px;font-weight:bold;">{{ (food.price+item.attributePrice) }} {{seller.unit}}</span>
                    </div>
                </div>
                <div style="padding-left: 20px;padding-right: 20px;margin-bottom: 20px;line-height: 40px;background-color:#F2F6FC;">
                     {{$t('orderList.choice')}} : {{food.decideName}}
                </div>
                <div style="padding-left: 20px;">
                    <div style="text-align: right;padding-right: 20px;">
                    <span style="font-weight:bold;font-size: 14px;">
                        {{$t('orderList.total')}}
                    </span>&nbsp;
                    <span style="color: #f01414;font-size: 20px;font-weight: 600;">
                        {{food.payAmount}}
                    </span>
                    <span style="color: #f01414;font-size: 14px;">
                        {{seller.unit}}
                    </span>
                </div>
                    <!-- <div style="text-align: right;margin-right: 20px;margin-top: -30px; "><mu-button color="success" class="notranslate"  @click="sureTasteSheet" style="text-transform:unset;">{{$t('common.sure')}}</mu-button></div> -->
                </div>
                <div style="padding: 20px;margin-bottom: 20px;">
                    <mu-button color="primary" large full-width @click="sureTasteSheet" style="background-color:#da5b3a;text-transform: unset;">
                        {{$t('common.sure')}}
                    </mu-button>
                </div>
            </mu-list>
        </mu-bottom-sheet>
        <mu-bottom-sheet :open.sync="openMulSelect" style="overflow-y: auto; height: 80%;">
            <mu-list @item-click="openMulSelect=false">
                  <mu-sub-header style="padding-left: 10px;font-size: 20px;font-weight: 600;line-height: 24px;padding-top: 5px;">{{food.foodName}}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon notranslate" @click="openMulSelect=false"></mu-icon>
                <div class="order-container" style="max-width: 500px; margin: 0px auto; padding: 15px;">
                    <div class="config" style="margin-bottom:15px; padding-bottom:10px; border-bottom:1px solid #eee;">
                        <div>{{$t('orderList.personNum')}}:<input v-model.number="personNum" @change="changeData" type="number" min="1" 
                                style="width:60px;"></div>
                        <div style="margin-top:5px;">{{$t('orderList.maxiNum')}}:<input v-model.number="maxPerPerson" type="number" min="1"
                                 style="width:60px;"></div>
                        <div style="margin-top:5px;">{{$t('orderList.upperLimit')}}：{{ totalMax }}</div>
                    </div>

                    <!-- 菜品选择区 -->
                   <div class="attribute-list">
                        <button v-for="(item, index) in mulList" :key="index" @click="openAddDialog(item)"
                            :disabled="globalUsed >= totalMax" class="attribute-btn">
                            {{ item.attributeName }}
                        </button>
                    </div>

                  <!-- 已选列表 多选 -->
                    <div class="selected-list">
                        <div class="selected-title">
                            <strong>{{$t('orderList.selectedList')}}</strong>
                            <span>({{ globalUsed }}/{{ totalMax }})</span>
                        </div>
                        <div class="selected-empty" v-if="selectedList.length === 0">
                            {{$t('orderList.clickToSelect')}}
                        </div>
                        <div v-for="(item, index) in selectedList" :key="index" class="selected-item">
                            <div class="selected-info">
                                <span class="food-name">{{ item.attribute.attributeName }}</span>
                                <span class="user-tag" v-if="item.user">{{ item.user }}</span>
                                <span class="num">× {{ item.num }}</span>
                            </div>
                            <button @click="deleteItem(index)" class="del-btn">
                                  {{$t('orderList.delete')}}
                            </button>
                        </div>
                    </div>

                       <div style="padding: 20px;margin-bottom: 20px;">
                    <mu-button color="primary" large full-width @click="sureMulSelect" style="background-color:#da5b3a;text-transform: unset;">
                        {{$t('common.sure')}}
                    </mu-button>
                </div>

                  <!-- 加菜弹窗 -->
                    <div v-if="showDialog"
                        style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:999;">
                        <div  style="background:#fff;border-radius:14px;overflow:hidden;min-width:300px;box-shadow:0 4px 25px rgba(0,0,0,0.15);">
                            <div
                                style="padding:22px 15px;text-align:center;font-size:17px;font-weight:bold;color:#333;">
                                {{ currAttribute.attributeName }}
                            </div>
                            <div style="padding:0 25px 25px;">
                                <div style="margin-bottom:20px;">
                                    <label
                                        style="font-size:15px;color:#333;display:block;margin-bottom:10px;">{{$t('orderList.units')}}</label>
                                    <div
                                        style="display:flex;align-items:center;border:1px solid #eaeefb;border-radius:8px;overflow:hidden;width:180px;">
                                        <button @click="addNum = Math.max(1, addNum - 1)"
                                            style="width:50px;height:44px;border:none;background:#f7f8fa;font-size:18px;color:#333;">-</button>
                                        <input v-model.number="addNum" type="number" min="1" max="99"
                                            style="flex:1;height:44px;border:none;text-align:center;font-size:16px;outline:none;">
                                        <button @click="addNum += 1"
                                            style="width:50px;height:44px;border:none;background:#f7f8fa;font-size:18px;color:#333;">+</button>
                                    </div>
                                </div>
                                <div>
                                    <label
                                        style="font-size:15px;color:#333;display:block;margin-bottom:10px;">{{$t('orderList.who')}}</label>
                                    <input v-model="addUser" :placeholder="$t('orderList.nullRemark')"
                                        style="width:100%;height:46px;padding:0 12px;border:1px solid #eaeefb;border-radius:8px;font-size:15px;outline:none;">
                                </div>
                            </div>
                            <div style="display:flex;border-top:1px solid #eaeefb;">
                                <button @click="showDialog = false"
                                    style="flex:1;height:54px;line-height:54px;text-align:center;background:#fff;border:none;font-size:16px;color:#666;">{{$t('common.cancel')}}</button>
                                <div style="width:1px;background:#eaeefb;"></div>
                                <button @click="confirmAdd"
                                    style="flex:1;height:54px;line-height:54px;text-align:center;background:#fff;border:none;font-size:16px;color:#26a2ff;">{{$t('common.ok')}}</button>
                            </div>

                        </div>
                    </div>

                 
                </div>
            </mu-list>
        </mu-bottom-sheet>
    </div>   
</template>

<script>
  import Vue from 'vue'
import { eventBus } from '../utils/event-bus'

  export default {
        props: {
            packageType: {
                type: Number,
                default: 0
            },
            food: {
                type: Object
          },
          addType: {
              type: Boolean
          },
          personNum:{
                type: Number,
                default: 1
            },
        },
        data() {
            return {
                foodAttributeAll: [],
                foodAttribute: [],
                open: false,
                openMulSelect:false,
                tableOrderInfo:{},
                seller:{},
                maxPerPerson: 1,      // 每人最多几份（可配置）
                globalUsed: 0,
                totalMax: 2,
                currAttribute: '',
                addNum: 1,
                addUser: '',
                showDialog: false,
                selectedList:[],
                mulList:[]
            }
        },
        created() {
            
        },
        mounted() {
        },
    methods: {
    
    // 打开加菜弹窗
    openAddDialog(attribute) {
      this.currAttribute = attribute
      this.addNum = 1
      this.addUser = ''
      this.showDialog = true
    },
    
    // 确认加菜
    confirmAdd() {
      const attribute = this.currAttribute
      const num = this.addNum
      const user = this.addUser
      
      // 校验份数必须 ≥1
      if (num < 1) {
         this.$alert(this.$t('orderList.needMax1'), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
        return
      }
      
      // 校验全局上限
      if (this.globalUsed + num > this.totalMax) {
         this.$alert(this.$t('orderList.upperMaxLimit')+`${this.totalMax - this.globalUsed} `, this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
        return
      }
      
      // 如果填了归属人 → 校验该用户是否超限
      if (user) {
        const userUsed = this.getUserUsed(user)
        if (userUsed + num > this.maxPerPerson) {
          this.$alert(this.$t('orderList.oneLimit', { user:user,maxPerPerson: this.maxPerPerson,userUsed:userUsed }), { type: 'warning', okLabel: this.$t("common.ok") });
          return
        }
      }
      
      // 添加到已选
      this.selectedList.push({
        attribute,
        user,
        num
      })
      
      // 更新已用总数
      this.globalUsed += num
      this.showDialog = false
    },
    
    // 获取某个用户已点份数
    getUserUsed(user) {
      return this.selectedList.reduce((sum, item) => {
        return item.user === user ? sum + item.num : sum
      }, 0)
    },
    
    // 删除一项
    deleteItem(index) {
      const item = this.selectedList[index]
      this.globalUsed -= item.num
      this.selectedList.splice(index, 1)
    },
      addCart(e) {
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1);
                if(this.food.chargedOnce==1 && this.food.payAmount>0){
                    var tips=this.$t("orderList.chargedOnceTips");
                    if(window.localStorage.getItem('oneTimeCharge')!=undefined && window.localStorage.getItem('oneTimeCharge')!=null && window.localStorage.getItem('oneTimeCharge')!=''){
                        tips=window.localStorage.getItem('oneTimeCharge');
                    }
                    this.$alert(tips, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                }
            } else {
                this.food.quantity += 1;
            }

        // 优化体验，异步传递当前点击文档节点
            this.$nextTick(() => {
                eventBus.$emit('addcart', e.target)
        })
      },
      decreaseCart () {
          if (this.food.quantity) {
              this.food.quantity--
               if(this.food.quantity==0){
                 Vue.set(this.food, 'payAmount', this.food.price)
               }
          }
        },
        getWith() {
            return this.$t('orderList.with');
        },
        selectTastes(it) {
            var decideNameArr=[];
            var extPrice=0;
            this.foodAttribute.forEach((item) => {
                if(item.id==it.parentId){
                    item.children.forEach((item1) => {
                        if(it.id==item1.id){
                            if(!item1.isChoice){
                                item1.isChoice=true;
                                extPrice+=item1.attributePrice;
                                decideNameArr.push(item1.attributeName);
                            }
                            else{
                                item1.isChoice=!item1.isChoice;
                            }
                        }
                        else{
                            if(item.model==1){
                                item1.isChoice=false;
                            }
                            else{
                                if(item1.isChoice){
                                    extPrice+=item1.attributePrice;
                                    decideNameArr.push(item1.attributeName);
                                }
                            }
                        }
                    })
                }
                else{
                    item.children.forEach((item1) => {
                        if(item1.isChoice){
                            extPrice+=item1.attributePrice;
                            decideNameArr.push(item1.attributeName);
                        }
                    })
                }
            })
            this.food.payAmount=parseFloat(Number((this.food.price * this.food.actDiscount)+extPrice).toFixed(0));
           let t=decideNameArr.join(',');
            if (this.food.decideName == null) {
                Vue.set(this.food, 'decideName', t)
            } else {
                this.food.decideName = t;
            }
        },
        sureTasteSheet(){
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1)
            } else {
                this.food.quantity += 1
            }
            this.open = false;
        },
        closeTasteSheet() {
            this.open = false;
        },
        openTasteSheet(groupId) {
            this.foodAttribute = [];
            Vue.set(this.food, 'decideName', null)
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.$get('QRCodeOrder/GetAllFoodCustomAttributeList', {restaurantId:this.tableOrderInfo.restaurantId})
                .then(response => {
                    if (response.code == 200) {
                        this.foodAttributeAll = response.data;;
                        var arr = response.data.filter(item => {
                            return groupId.indexOf(item.id) > -1
                        })
                        arr.forEach((parentItem) => {
                            parentItem.children = response.data.filter(item => {
                                return item.parentId == parentItem.id;
                            })
                        })
                        if(arr.length>0){
                            this.foodAttribute = arr;
                            if(this.foodAttribute[0].children.length>0){
                                this.selectTastes(this.foodAttribute[0].children[0]);
                            }
                           if(arr[0].model==2){
                             this.mulList=arr[0].children;
                             this.openMulSelect = true;
                             this.maxPerPerson=this.food.perMaxCopies;
                             if( this.maxPerPerson==null || this.maxPerPerson==0){
                                 this.maxPerPerson=1;
                             }
                             this.totalMax = this.personNum * this.maxPerPerson
                           }
                        }
                        if(!this.openMulSelect){
                             this.open = true;
                        }
                    }
                });
        },
        changeData(){
            this.totalMax = this.personNum * this.maxPerPerson
        },
        sureMulSelect(){
            if(!this.selectedList || this.selectedList.length==0){
                 this.$alert(this.$t('orderList.clickToSelect'), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                return;
            }
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1)
            } else {
                this.food.quantity += 1
            }
            const result = [];
            this.selectedList.forEach(item => {
                const dish = item.attribute.attributeName; // 菜品
                const num = item.num;
                const user = item.user;
                if (user!=null && user!='') {
                    result.push(`${dish} (${user}) ×${num}`);
                } else {
                    result.push(`${dish} ×${num}`);
                }
            });
            var remark = result.join(" | ");
            Vue.set(this.food, 'decideName', remark)
            this.openMulSelect = false;
        }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .cartcontroll {
        font-size: 0;
    }

        .cartcontroll .decrease,
        .cartcontroll .add {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #da5b3a;
            padding: 6px;
        }


        .cartcontroll .decrease-buffet,
        .cartcontroll .add-buffet {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #fff;
            padding: 6px;
        }


        .cartcontroll .count {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            font-weight:600;
            width: 30px;
            line-height: 30px;
            text-align: center;
            color: #da5b3a;
        }

        .cartcontroll .count-buffet {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            width: 20px;
            line-height: 30px;
            text-align: center;
            color: #fff;
        }

    .cartcontroll,
    .slide-fade-enter-active {
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        -webkit-transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        /* .slide-fade-leave-active for below version 2.1.8 */
        -webkit-transform: translateX(24px) rotate(360deg);
        transform: translateX(24px) rotate(360deg);
        opacity: 0;
    }

    .foods-wrapper {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow-y: scroll;
    }

     .foods-wrapper h1 {
        margin: 0px;
    }

     .foods-wrapper .title {
        padding-left: 14px;
        border-left: 2px solid #d9dde1;
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        color: #93999f;
        background-color: #f3f5f7;
    }

     .foods-wrapper .food-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 5px;
        padding-bottom: 10px;
        margin-right: 10px;
        position: relative;
    }

         .foods-wrapper .food-item:after {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-top: 1px solid rgba(7,17,27,0.1);
            content: '';
        }

         .foods-wrapper .food-item:last-child:after {
            border-top: 0;
        }

         .foods-wrapper .food-item .icon {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 57px;
            flex: 0 0 57px;
            margin-right: 10px;
        }

         .foods-wrapper .food-item .content {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            margin-left: 5px;
        }

             .foods-wrapper .food-item .content .name {
                margin: 2px 0 8px 0;
                height: 12px;
                line-height: 12px;
                font-size: 14px;
                color: #07111b;
            }

             .foods-wrapper .food-item .content .description,
             .foods-wrapper .food-item .content .extra {
                font-size: 10px;
                line-height: 10px;
                color: #93999f;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                height: 10px;
                line-height: 10px;
            }

                 .foods-wrapper .food-item .content .extra .count {
                    margin-right: 12px;
                    line-height: 10px;
                }

                 .foods-wrapper .food-item .content .extra .rating {
                    line-height: 10px;
                }

             .foods-wrapper .food-item .content .price .now {
                font-size: 12px;
                color: #f01414;
                font-weight: 700;
                line-height: 24px;
                padding:5px;
            }

             .foods-wrapper .food-item .content .price .old {
                font-size: 12px;
                text-decoration: line-through;
                color: #93999f;
                font-weight: 700;
                line-height: 24px;
            }

             .foods-wrapper .food-item .content .cart-wrapper {
                position: absolute;
                right: 0;
                bottom: 12px;
            }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }

    .material-icons {
    font-size:36px;
    }
    .badge-class {
    font-size:18px;
    }
    .stateChoose {
        height: 32px;
        background: #fffbf2;
        border: 1px solid #ef9350;
        border-radius: 10px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        color: #DA5B3A;
        padding: 0px 20px 0px 20px;
        line-height: 32px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        width:auto; 
        text-align: left;
        display: inline-block;
      }
       
      .stateNotChoose {
        height: 32px;
        background: #ffffff;
        border: 1px solid #E4E7ED;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #363636;
        line-height: 32px;
        padding: 0px 20px 0px 20px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        text-align: left;
        display: inline-block;
      }

      /* 菜品列表布局 */
.attribute-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  padding: 0 4px;
}

/* 按钮主体样式 —— 完全贴合 mu-bottom-sheet 底部弹窗风格 */
.attribute-btn {
  flex: none; /* 关键：不自动撑满 */
  min-width: 100px;
  padding: 10px 16px; /* 左右内边距足够，文字长就自动变宽 */
  height: 44px;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  font-size: 14px;
  color: #333;
  white-space: nowrap; /* 文字不换行 */
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 鼠标/手指按下效果 */
.attribute-btn:active {
  background: #f5f6f7;
  transform: scale(0.96);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 禁用态（达到总上限）*/
.attribute-btn:disabled {
  background: #f7f8fa;
  color: #c9c9c9;
  border-color: #eee;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
/* 已选列表容器 */
.selected-list {
  margin-bottom: 20px;
  padding: 0 4px;
}
/* 标题 */
.selected-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
}
.selected-title span {
  color: #999;
  font-size: 13px;
  margin-left: 6px;
}
/* 空状态 */
.selected-empty {
  color: #ccc;
  font-size: 14px;
  padding: 10px 0;
  text-align: center;
}
/* 每一项卡片 */
.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafbfc;
  border: 1px solid #f0f1f5;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 8px;
}
/* 左侧信息 */
.selected-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
}
/* 菜品名称 */
.food-name {
  font-weight: 500;
}
/* 归属人标签 */
.user-tag {
  background: #e8f3ff;
  color: #26a2ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}
/* 份数 */
.num {
  color: #666;
  font-size: 13px;
}
/* 删除按钮 */
.del-btn {
  background: #fff0f0;
  color: #fa3f3f;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}
.del-btn:active {
  background: #ffe0e0;
}
</style>



// WEBPACK FOOTER //
// src/components/CartControl.vue